import { useAuth } from '../hooks/useAuth';

const VIEW_TITLES = {
  overview: 'Overview',
  people: 'People',
  teams: 'All Teams',
  schedule: 'Master Schedule',
  meals: 'Meal Counts',
  access: 'Team Lead Access',
  'admin-manual': 'SL Manual',
  'past-2025': '2025 Conference',
};

function getTitleFromView(view) {
  if (VIEW_TITLES[view]) return VIEW_TITLES[view];
  if (view.startsWith('tl-')) {
    // Role roster: tl-{teamId}-roster-{roleName}
    const rosterMatch = view.match(/-roster-(.+)$/);
    if (rosterMatch) return `${rosterMatch[1]} Roster`;
    // Other suffixes: tl-{teamId}-{suffix}
    const suffixMatch = view.match(/-(people|roster|schedule|manual)$/);
    if (suffixMatch) {
      const titles = { people: 'People', roster: 'Roster', schedule: 'Team Schedule', manual: 'Team Documents' };
      return titles[suffixMatch[1]];
    }
  }
  return 'Dashboard';
}

export default function Topbar({ currentView, isAdmin, tlViewActive, onToggleTLView, previewTeamName, teamsReady, showToast, onOpenSidebar }) {
  const { signOut } = useAuth();

  return (
    <div className="topbar">
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <button className="hamburger" onClick={onOpenSidebar} aria-label="Open menu">
          <span /><span /><span />
        </button>
        <div className="topbar-title">{getTitleFromView(currentView)}</div>
      </div>
      <div className="topbar-right">
        <span className="year-badge">2026</span>
        {isAdmin && tlViewActive && previewTeamName && (
          <span className="preview-label">
            Previewing: <strong style={{ fontFamily: 'var(--font-h)', color: 'var(--black)' }}>{previewTeamName}</strong>
          </span>
        )}
        {isAdmin && (
          <button
            className={`btn btn-sm${tlViewActive ? ' tl-active' : ''}`}
            onClick={onToggleTLView}
            disabled={!tlViewActive && !teamsReady}
            title={!tlViewActive && !teamsReady ? 'Loading your teams…' : undefined}
          >
            {!tlViewActive && !teamsReady
              ? 'Loading…'
              : tlViewActive
                ? (previewTeamName ? '← Back' : 'Admin View')
                : 'Team Lead View'
            }
          </button>
        )}
        <button className="btn btn-sm" onClick={signOut}>Sign Out</button>
      </div>
    </div>
  );
}
